import ApiaField from '../ApiaField';
import ApiaForm from '../ApiaForm';
import Field from '../constants/Field';
import { IApiaField } from '../types';

export type TTextAreaField = IApiaField;

export default class TextAreaField extends ApiaField implements TTextAreaField {
  constructor(field: HTMLTextAreaElement, form: ApiaForm) {
    super(field, form, [
      Field.PROPERTY_INPUT_AS_TEXT,
      Field.PROPERTY_REQUIRED,
      Field.PROPERTY_DISABLED,
      Field.PROPERTY_READONLY,
      Field.PROPERTY_VISIBILITY_HIDDEN,
      Field.PROPERTY_TRANSLATION_REQUIRED,
      Field.PROPERTY_SHOW_TOOLTIP_AS_HELP,
    ]);
  }
}
